import React from "react";
import {
  Col,
  Row,
  Switchbox,
  Typography
} from "../../../ppui";
import {
  Card,
  CardHeading,
  LabourWelfareBody,
  LabourWelfareHeader,
  LabourWelfareTable,
  LabourWelfareTd,
  LabourWelfareTh,
  LabourWelfareTr,
} from "../../style";
import LabourWelfare from "./labour-welfare";


const StatutoryLabourwelfare = () => {
  const {show,ToggleFunction}=LabourWelfare()
  return (
    <>
    <Card>
      <CardHeading  Divider>
        Labour Welfare Information
        <Switchbox color="Primary" size="md" checked={show}  onChange={ToggleFunction} lableFirst label={`${show?"Disable":"Enable"}`}/>
      </CardHeading>
      <Typography variant="body2" mb={"20"}>
        Labour Welfare Fund act ensures social security and improves
        working conditions for employees
      </Typography>
      <Row>
        <Col sm={12} md={6}>
          <LabourWelfareTable>
            <LabourWelfareHeader>
              <LabourWelfareTr>
                <LabourWelfareTh>
                  <Typography variant="h5" mb={"0"}>
                    West Bengal
                  </Typography>
                </LabourWelfareTh>
                <LabourWelfareTh></LabourWelfareTh>
              </LabourWelfareTr>
            </LabourWelfareHeader>

              <LabourWelfareBody>
                <LabourWelfareTr>
                  <LabourWelfareTd>
                    <Typography variant="body1" mb={0}>
                      {`Employee's`} Contribution
                    </Typography>
                  </LabourWelfareTd>
                  <LabourWelfareTd>
                    <Typography variant="body1" mb={0}>
                      ₹ 3.00
                    </Typography>
                  </LabourWelfareTd>
                </LabourWelfareTr>

                <LabourWelfareTr>
                  <LabourWelfareTd>
                    <Typography variant="body1" mb={0}>
                      {`Employer's`} Contribution
                    </Typography>
                  </LabourWelfareTd>
                  <LabourWelfareTd>
                    <Typography variant="body1" mb={0}>
                      ₹ 30.00
                    </Typography>
                  </LabourWelfareTd>
                </LabourWelfareTr>

                <LabourWelfareTr>
                  <LabourWelfareTd>
                    <Typography variant="body1" mb={0}>
                      Deduction Cycle
                    </Typography>
                  </LabourWelfareTd>
                  <LabourWelfareTd>
                    <Typography variant="body1" mb={0}>
                      Half Yearly
                    </Typography>
                  </LabourWelfareTd>
                </LabourWelfareTr>
              </LabourWelfareBody>
            </LabourWelfareTable>
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default StatutoryLabourwelfare;
